export const axisFont = {
  family: 'neue-haas-grotesk-display, Helvetica Neue, Segoe UI, Roboto, sans-serif',
  size: 22,
  color: '#33403F'
}
